import React, { Component } from 'react';
import config from '../config';
import fetcher from "../context/fetcher";

const STORAGE_KEY = "service-tests-events-config";

function createDefaultDeviceId() {
    return `admin-test-${Date.now()}`;
}

export default class ServiceTests extends Component {
    constructor(props) {
        super(props);

        let saved = {};
        try {
            saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
        } catch (e) {
            saved = {};
        }

        this.state = {
            authUrl: saved.authUrl || "",
            offersUrl: saved.offersUrl || "",
            deviceId: saved.deviceId || createDefaultDeviceId(),
            loading: false,
            error: null,
            result: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.runEventsScenario = this.runEventsScenario.bind(this);
        this.regenerateDeviceId = this.regenerateDeviceId.bind(this);
        this.saveConfig = this.saveConfig.bind(this);
    }

    saveConfig(nextState) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            authUrl: nextState.authUrl,
            offersUrl: nextState.offersUrl,
            deviceId: nextState.deviceId
        }));
    }

    handleChange(e) {
        const nextState = {
            ...this.state,
            [e.target.name]: e.target.value
        };
        this.setState({
            [e.target.name]: e.target.value
        });
        this.saveConfig(nextState);
    }

    regenerateDeviceId() {
        const deviceId = createDefaultDeviceId();
        const nextState = {
            ...this.state,
            deviceId
        };
        this.setState({ deviceId });
        this.saveConfig(nextState);
    }

    async runEventsScenario() {
        this.setState({
            loading: true,
            error: null
        });

        try {
            const response = await fetcher(`${config.API()}service-tests/events/auth-and-get-data`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    authUrl: this.state.authUrl,
                    offersUrl: this.state.offersUrl,
                    deviceId: this.state.deviceId
                })
            });
            const result = await response.json();
            this.setState({
                loading: false,
                result,
                error: result.ok ? null : (result.msg || 'Scenario failed')
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error.message || 'Scenario failed',
                result: null
            });
        }
    }

    renderStep(step, index) {
        return (
            <div className="card mb-3" key={`step-${index}`}>
                <div className="card-header py-2 d-flex justify-content-between">
                    <strong>{step.name}</strong>
                    <span className={step.ok ? "text-success" : "text-danger"}>
                        {step.ok ? "ok" : "error"} | {step.elapsedMs} ms
                    </span>
                </div>
                <div className="card-body">
                    <div className="mb-2"><b>Request</b></div>
                    <pre className="small bg-light p-2 border">{JSON.stringify(step.request, null, 2)}</pre>
                    {step.response && (
                        <div>
                            <div className="mb-2"><b>Response</b></div>
                            <pre className="small bg-light p-2 border">{JSON.stringify(step.response, null, 2)}</pre>
                        </div>
                    )}
                    {step.error && (
                        <div>
                            <div className="mb-2 text-danger"><b>Error</b></div>
                            <pre className="small bg-light p-2 border">{JSON.stringify(step.error, null, 2)}</pre>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <div className="card shadow w-100">
                    <div className="card-header py-3">
                        <h2 className="m-0 font-weight-bold">Service tests</h2>
                    </div>
                    <div className="card-body">
                        <div className="card mb-4">
                            <div className="card-header py-2">
                                <strong>Scenario: auth/create user -&gt; events/data</strong>
                            </div>
                            <div className="card-body">
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Auth URL</label>
                                    <div className="col-sm-10">
                                        <input
                                            className="form-control"
                                            name="authUrl"
                                            value={this.state.authUrl}
                                            onChange={this.handleChange}
                                            placeholder="http://localhost:5001"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Offers URL</label>
                                    <div className="col-sm-10">
                                        <input
                                            className="form-control"
                                            name="offersUrl"
                                            value={this.state.offersUrl}
                                            onChange={this.handleChange}
                                            placeholder="http://localhost:5002"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Device ID</label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            name="deviceId"
                                            value={this.state.deviceId}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-sm-2">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-block"
                                            onClick={this.regenerateDeviceId}
                                        >
                                            Regenerate
                                        </button>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={this.runEventsScenario}
                                        disabled={this.state.loading}
                                    >
                                        {this.state.loading ? "Running..." : "Run scenario"}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {this.state.error && (
                            <div className="alert alert-danger">{this.state.error}</div>
                        )}

                        {this.state.result && (
                            <div>
                                <div className={`alert ${this.state.result.ok ? "alert-success" : "alert-warning"}`}>
                                    <div><b>Status:</b> {this.state.result.ok ? "ok" : "failed"}</div>
                                    {this.state.result.deviceId && <div><b>Device ID:</b> {this.state.result.deviceId}</div>}
                                    {this.state.result.auth && this.state.result.auth.userId && (
                                        <div><b>User ID:</b> {this.state.result.auth.userId}</div>
                                    )}
                                </div>

                                {this.state.result.steps && this.state.result.steps.map((step, index) => this.renderStep(step, index))}

                                <div className="card">
                                    <div className="card-header py-2"><strong>Full result</strong></div>
                                    <div className="card-body">
                                        <pre className="small bg-light p-2 border">{JSON.stringify(this.state.result, null, 2)}</pre>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
